import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import {
    Link,
    Redirect
} from 'react-router-dom'
import Toggle from 'react-toggle'
import ActionButton from "../../common/button/actionbutton.component.jsx"
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import ConnectIntegrationButton from "../../common/button/connectintegrationbutton.component.jsx"
import CopyableInputForm from "../../common/form/copyableinput.component.jsx"
import GlobalHelper from '../../common/GlobalHelper.jsx'
import LoadingSpinner from "../../common/spinner/loading.component"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import IntegrationConfigurationValue from '../../state/integration/IntegrationConfigurationValue'
import {
    integrationKeyKangaroo, integrationKeyLightspeedGolf, integrationKeyWix, integrationKeyZapier, integrationKeyZapierMu2,
    integrationKeyZendeskSell,
    integrationKeyZendeskSupport
} from '../IntegrationConstants.jsx'
import FreshbooksFormComponent from './freshbooks/FreshbooksFormComponent'
import HubSpotFormComponent from './hubspot/HubSpotFormComponent'
import LSEcomForm from './ls-ecom/LSEcomFormComponent'
import LsRetailForm from './ls-retail/LSRetailFormComponent'
import { MailchimpEditForm } from "./mailchimp"
import PipedriveFormComponent from './pipedrive/pipedriveFormComponent'
import QuickbooksForm from "./quickbooks/QuickbooksFormComponent"
import RainforestFormComponent from './rainforest/RainforestFormComponent'
import ShopifyForm from './shopify/ShopifyFormComponent'
import SquarePaymentsFormComponent from './square/SquarePaymentsFormComponent'
import StripeForm from './stripe/StripeFormComponent'
import VendForm from './vend/VendFormComponent'
import WixFormComponent from './wix/WixFormComponent'
import ZendeskSupportFormComponent from './zendesk-support/ZendeskSupportFormComponent'
const queryString = require('query-string')

const messages = defineMessages({
    "smtp_host_placeholder": {
        id: 'integration.form.edit.custom_smtp.host_placeholder',
        defaultMessage: 'i.e: smtp.example.com',
    },
    "contact_support": {
        id: 'integration.form.edit.contact_support_golf',
        defaultMessage: 'Contact Support',
    },
    "smtp_port_placeholder": {
        id: 'integration.form.edit.custom_smtp.port_placeholder',
        defaultMessage: 'i.e: 465',
    },
    "smtp_sender_email_placeholder": {
        id: 'integration.form.edit.custom_smtp.sender_email_placeholder',
        defaultMessage: 'i.e: info@example.com',
    },
    "smtp_username_placeholder": {
        id: 'integration.form.edit.custom_smtp.username_placeholder',
        defaultMessage: 'i.e: info@example.com',
    },
    "smtp_password_placeholder": {
        id: 'integration.form.edit.custom_smtp.password_placeholder',
        defaultMessage: 'i.e: EbuwiRAOArUpt',
    },
    "stripe_pub_key_placeholder": {
        id: 'integration.form.edit.stripe.pub_key_placeholder',
        defaultMessage: 'i.e: pk_Skgd7VHvEbuwiRAOArUpt',
    },
    "stripe_secret_key_placeholder": {
        id: 'integration.form.edit.stripe.secret_key_placeholder',
        defaultMessage: 'i.e: sk_Skgd7VHvEbuwiRAOArUpt',
    },
    "api_key_placeholder": {
        id: 'integration.form.edit.d_tools.api_key_placeholder',
        defaultMessage: 'i.e: q54R39UBr0Skgd7VHvEbuwiRAOArUpt02o7z/vY+iwrg',
    },
    "submit_btn": {
        id: 'integration.form.edit.submit_btn',
        defaultMessage: 'Save',
    },
    "choose_option": {
        id: 'integration.form.edit.choose_option',
        defaultMessage: 'Choose',
    },
})


class IntegrationEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            integrationKey: this.props.type || '',
            configurationValues: [],
            enabledFeatures: {},
            hash: "",
            formOptions: {
                inputFormValues: [],
                requiredFields: [],
                buttonVisibility: [],
                buttonClassName: "",
                textAfterSubmission: "",
                buttonPlaceHolder: "",
                formSendButtonLabel: "",
                formCancelButtonLabel: "",
                buttonLabel: "",
                formTitle: "",
                inputFormOptions: [],
                inputRequiredOptions: [],
                buttonVisibilityOptions: [],
                userId: "",
                buttonPosition: "",
            },
            configuration: {
                apiKey: '',
                secretKey: '',
                publicKey: '',
                host: '',
                port: '',
                username: '',
                password: '',
                senderEmail: '',
                locationIds: [],
                createdByUserId: '',
                isTls: false,
                USD_creditCard_accountId: '',
                CAD_creditCard_accountId: '',
                USD_directDebit_accountId: '',
                CAD_directDebit_accountId: '',
                testMode: false,
                url: '',
                refreshToken: '',
                isUpdateFeedDisabled: false,
                showHiddenProducts: true,
                isInvoiceExportedAsFulfilled: false,
                isTaxExclusive: true,
                configToggles: {},
                createQuoteOnFormSubmission: false,
            },
            publicKey: '',
            secretKey: '',
            authConnect: this.props.authConnect,
            isEnabled: true,
            isLoading: this.props.value && this.props.value.id,
        }

        this.submitIntegration = this.submitIntegration.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteIntegration = this.deleteIntegration.bind(this)
        this.openIntercom = this.openIntercom.bind(this)
        this.getLightspeedGolfForm = this.getLightspeedGolfForm.bind(this)
        this.submitButtonIsEnabled = this.submitButtonIsEnabled.bind(this)
        this.getFormFooter = this.getFormFooter.bind(this)
    }

    componentDidMount() {
        const integration = this.props.value
        if (this.state.integrationKey == INTEGRATION_KEY.PIPEDRIVE && this.props.location && this.props.location.search) {
            const uri = queryString.parse(this.props.location.search)
            if (uri && uri.closeTab) {
                window.close()
            }
        }

        if (integration && integration.id) {
            this.setState({
                id: integration.id,
                locationIds: integration.attributes.locationIds && integration.attributes.locationIds.length > 0 ? integration.attributes.locationIds : [""],
                integrationKey: integration.attributes.integrationKey,
                configuration: integration.attributes.configuration,
                hash: integration.attributes.configuration.hash || "",
                enabledFeatures: integration.attributes.enabledFeatures,
                createdByUserId: integration.attributes.createdBy,
                publicKey: integration.attributes.publicKey,
                secretKey: integration.attributes.secretKey,
                authConnect: this.state.authConnect
            })
            AppContext.getApiClient().get('/integration-configurations/' + integration.id + '/configuration-values').then(res => {
                this.setState({
                    configurationValues: res.data,
                    isLoading: false,
                })
            })
        }
    }

    openIntercom(event) {
        event.preventDefault()
        if (window.Intercom) {
            window.Intercom('show')
        }
    }

    deleteIntegration(event) {
        const integration = this.props.value
        AppContext.getApiClient().delete('/integration-configurations/' + integration.id).then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/integrations/listing'
                    }}
                />
            }
            AppContext.loadIntegrations()
            this.setState({ formStatus: formStatus })
        })

        event.preventDefault()
    }

    saveIntegration(formOptionsPayload) {
        let configurationValues = this.state.configuration
        if (!GlobalHelper.hasGolfIntegration() && configurationValues['priceListCreditMemoPaymentTypeId']) {
            configurationValues['priceListCreditMemoPaymentTypeId'] = ""
        }

        let initialParameters = {
            locationIds: this.state.locationIds?.includes("") ? [] : this.state.locationIds,
            configuration: configurationValues,
            enabledFeatures: this.state.enabledFeatures,
        }

        let sentParameters = { ...initialParameters, ...formOptionsPayload }
        const integration = this.props.value
        if (integration && integration.id) {
            return AppContext.getApiClient().patch('/integration-configurations/' + integration.id, sentParameters)
        } else {
            return AppContext.getApiClient().post('/integration-configurations', {
                "locationIds": this.state.locationIds,
                "configuration": this.state.configuration,
                "integrationKey": this.state.integrationKey,
            })
        }
    }

    submitIntegration(event, formOptionsPayload) {
        this.saveIntegration(formOptionsPayload).then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect to={{ pathname: '/integrations/listing' }} />
                if (this.state.id === '') {
                    switch (this.state.integrationKey) {
                        case integrationKeyZendeskSupport:
                        case integrationKeyZapierMu2:
                        case integrationKeyZapier:
                            formStatus = <Redirect to={{ pathname: '/integrations/edit/' + response.id }} />
                            break
                    }
                }
            }
            this.setState({ formStatus: formStatus }, () => window.location.reload())
        })

        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name
        const conf = this.state.configuration
        switch (target.name) {
            case "configurationApiKey":
                conf.apiKey = value
                break
            case "configurationPublicKey":
                conf.publicKey = value
                break
            case "configurationSecretKey":
                conf.secretKey = value
                break
            case "configurationHost":
                conf.host = value
                break
            case "configurationPort":
                conf.port = value
                break
            case "configurationUsername":
                conf.username = value
                break
            case "configurationPassword":
                conf.password = value
                break
            case "configurationSenderEmail":
                conf.senderEmail = value
                break
            case "configurationIsTls":
                conf.isTls = value
                break
            case "refreshToken":
                conf.refreshToken = value
                break
            default:
                this.setState({
                    [name]: value
                })
                return
        }
        this.setState({
            configuration: conf
        })
    }

    renderConfigurationValueLabel(key) {
        switch (key) {
            case 'shopId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.shop_id"
                    defaultMessage="Shop"
                />
            case 'registerId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.register_id"
                    defaultMessage="Register"
                />
            case 'employeeId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.employee_id"
                    defaultMessage="Employee"
                />
            case 'bankTransferPaymentTypeId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.bank_transfer_payment_type_id"
                    defaultMessage="Payment type for bank transfer"
                />
            case 'cashPaymentTypeId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.cash_payment_type_id"
                    defaultMessage="Payment type for cash"
                />
            case 'creditCardPaymentTypeId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.credit_card_payment_type_id"
                    defaultMessage="Payment type for credit card"
                />
            case 'checkPaymentTypeId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.check_payment_type_id"
                    defaultMessage="Payment type for cheque"
                />
            case 'priceListCreditMemoPaymentTypeId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.price_list_credit_memo_payment_type_id"
                    defaultMessage="Event Registration Deposit payment type"
                />
            case 'transferPaymentTypeId':
                return <FormattedMessage
                    id="integration.form.edit.lightspeed.transfer_payment_type_id"
                    defaultMessage="Credit transfers between customer accounts"
                />
            case 'defaultIncomeAccountId':
                return <FormattedMessage
                    id="integration.form.edit.quickbook.default_income_account_id"
                    defaultMessage="Default income account"
                />
            case 'inputFormValues':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.input_form_values"
                    defaultMessage="Form Options"
                />
            case 'requiredFields':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.required_fields"
                    defaultMessage="Required Fields"
                />
            case 'buttonVisibility':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.button_visibility"
                    defaultMessage="Quote Button Visibility"
                />
            case 'buttonClassName':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.button_className"
                    defaultMessage="Button ClassName"
                />
            case 'textAfterSubmission':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.text_after_submission"
                    defaultMessage="Text After Form Submission"
                />
            case 'buttonPlaceHolder':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.button_placeHolder"
                    defaultMessage="Button Placeholder"
                />
            case 'formSendButtonLabel':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.formSendButtonLabel"
                    defaultMessage="Form Send Button Label"
                />
            case 'formCancelButtonLabel':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.formCancelButtonLabel"
                    defaultMessage="Form Cancel Button Label"
                />
            case 'buttonLabel':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.buttonLabel"
                    defaultMessage="Request Quote Button Label"
                />
            case 'formTitle':
                return <FormattedMessage
                    id="integration.form.edit.ls_ecom.formTitle"
                    defaultMessage="Form Title"
                />
            case 'organizationId':
                return <FormattedMessage
                    id="integration.form.edit.ls_golf.organization_id"
                    defaultMessage="Organization"
                />
            case "buttonPosition":
                return <FormattedMessage
                    id="integration.form.edit.ecom.request_button_position_label"
                    defaultMessage="Button Position"
                />
            default:
                return key
        }
    }

    renderFeatureLabel(key) {
        switch (key) {
            case 'approved-quote-auto-export':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.approved_quote_auto_export"
                    defaultMessage="Auto export approved quote"
                />
            case 'contact-export':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.contact_export"
                    defaultMessage="Contact export"
                />
            case "contact-import":
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.contact_import"
                    defaultMessage="Contact import"
                />

            case "inventory-cron-import":
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.inventory_sync"
                    defaultMessage="Inventory sync"
                />
            case 'inventory-sync':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.show_inventory"
                    defaultMessage="Show inventory"
                />
            case 'product-sync':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.product_sync"
                    defaultMessage="Product sync"
                />
            case 'sent-invoice-auto-export':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.sent_invoice_auto_export_sync"
                    defaultMessage="Auto export of sent invoice"
                />
            case 'product-export':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.product_export"
                    defaultMessage="Export products"
                />
            case 'invoice-sync':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.invoice_sync"
                    defaultMessage="Auto import sales paid with a credit account"
                />
            case 'payment-sync':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.payment_sync"
                    defaultMessage="Auto import deposit and payment made on credit account"
                />
            case 'external-pricing-calculation':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.external_pricing_calculation"
                    defaultMessage="Apply price rules"
                />
            case 'override-invoice-number':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.override_invoice_number"
                    defaultMessage="Override invoice number"
                />
            case 'export-organizations-on-invoices':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.export_organizations_on_invoices"
                    defaultMessage="Contact on exported invoices should be the organization when possible"
                />
            case 'short-description-product-import':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.product_import_short_description"
                    defaultMessage="Import product short description"
                />
            case 'external-order-cron-import':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.external_order_sync"
                    defaultMessage="Sales Receipt Sync"
                />
            case 'payment-import-create-credit-memo':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.payment_import_create_credit_memo"
                    defaultMessage="Create credit memos when payments are imported instead of applying them automatically"
                />
            case 'integrated-payment-bank-transfer':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.integrated_payment_bank_transfer_description"
                    defaultMessage="Bank transfer payment (ACH Direct Debit)"
                />
            case 'export-order-line-details-to-purchase-order':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.export_order_line_details_to_purchase_order_description"
                    defaultMessage="Export order lines notes to PO"
                />
            case 'purchase-order-tracking':
                return <FormattedMessage
                    id="integration.form.edit.feature_toggle.purchase_order_tracking_description"
                    defaultMessage="Create and track PO from orders"
                />
            default:
                return key
        }
    }

    renderConfigurationValues() {
        return this.state.configurationValues.map(c => {
            const options = []
            for (let key in c.attributes.values) {
                options.push(<option value={key} key={options.length}>
                    {c.attributes.values[key]}
                </option>)
            }
            return <div className="form-group row" key={c.id}>
                <label className="col-3 col-form-label text-align-right" htmlFor={c.id}>
                    {this.renderConfigurationValueLabel(c.attributes.key)}
                </label>
                <div className="col-9">
                    <select
                        name={c.id}
                        value={this.state.configuration[c.attributes.key]}
                        onChange={e => {
                            const conf = this.state.configuration
                            conf[c.attributes.key] = e.target.value
                            this.setState({
                                configuration: conf
                            })
                        }}
                        id={c.id}
                        className="form-control"
                    >
                        <option value={''}>{this.props.intl.formatMessage(messages['choose_option'])}</option>
                        {options}
                    </select>
                </div>
            </div>
        })
    }

    //Should be handled by sub form component
    submitButtonIsEnabled() {
        switch (this.state.integrationKey) {
            case integrationKeyLightspeedGolf:
                return false;
            default:
                return this.state.isEnabled
        }
    }

    //TO DO: make LsGolfForm component
    getLightspeedGolfForm() {
        let form = ""
        if (this.state.id != "") {
            form = <div className="col-12 ui-module">
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="lsGolfOrganizationName">
                        <FormattedMessage
                            id="integration.form.edit.organization_name"
                            defaultMessage="Golf Club:"
                        />
                    </label>
                    <div className="col-9">
                        {this.state.configurationValues && this.state.configurationValues.length > 0 &&
                            this.state.configuration && this.state.configurationValues[0].attributes.values ?
                            this.state.configurationValues[0].attributes.values[this.state.configuration.organizationId] : ""}
                    </div>
                </div>
            </div>
        } else {
            form = <div className="col-12 ui-module">
                <div className="form-group row justify-content-center">
                    <button
                        disabled={false}
                        onClick={this.openIntercom} className="btn btn-primary">
                        {this.props.intl.formatMessage(messages['contact_support'])}
                    </button>
                </div>
            </div>
        }
        return form
    }

    shouldRenderFeatureToggle(feature) {
        switch (feature) {
            case 'payment-sync'://invoice and payment are sync together now
                return false
            case 'inventory-sync':
                return !GlobalHelper.hasShopifyIntegration() && !GlobalHelper.hasShopifyExpertAppIntegration()
            default:
                return true
        }
    }

    renderFeatureToggles() {
        const featureToggles = []
        for (let feature in this.state.enabledFeatures) {
            if (!this.shouldRenderFeatureToggle(feature)) {
                continue
            }
            featureToggles.push(
                <div className="form-group row" key={feature}>
                    <label className="col-3 col-form-label text-align-right" htmlFor={feature}>
                        {this.renderFeatureLabel(feature)}
                    </label>
                    <div className="col-9 d-flex align-items-center">
                        <Toggle
                            id={feature}
                            defaultChecked={this.state.enabledFeatures[feature]}
                            icons={false}
                            onChange={() => {
                                const features = this.state.enabledFeatures
                                features[feature] = !this.state.enabledFeatures[feature]
                                this.setState({
                                    enabledFeatures: features,
                                })
                            }} />
                    </div>
                </div>
            )
        }
        return featureToggles
    }

    getFormFooter() {
        const integration = this.props.value
        let deleteButton = ''
        if (integration && integration.id &&
            (![
                INTEGRATION_KEY.SHOPIFY,
                INTEGRATION_KEY.SHOPIFY_EXPERT_APP,
                INTEGRATION_KEY.RAINFOREST,
            ].includes(integration.attributes.integrationKey) ||
                AppContext.getUserLoggedIn().attributes.superUser)
        ) {
            deleteButton = <ConfirmButton
                identifier={integration.attributes.integrationKey === 'quick-books' && <FormattedMessage
                    id="integration.form.edit.quickbooks_label"
                    defaultMessage="QuickBooks"
                />}
                onClick={this.deleteIntegration}
                className="btn btn-danger">
                <FormattedMessage
                    id="integration.form.edit.delete_btn"
                    defaultMessage="Delete integration"
                />
            </ConfirmButton>
        }
        const integrationHasOwnFooter = ['ls-ecom', 'ls-ecom-omni', 'ls-ecom-omni-na', integrationKeyWix].includes(this.state.integrationKey)
        return !integrationHasOwnFooter && < div className="col-12 ui-module" >
            {
                (!['paysafe'].includes(this.state.integrationKey) ||
                    AppContext.getUserLoggedIn().attributes.superUser) ?
                    <div className="row">
                        <div className="col-6">
                            {deleteButton}
                        </div>
                        <div className="col-6 text-align-right">
                            <Link to="/integrations/listing" className="btn btn-light">
                                <FormattedMessage
                                    id="integration.form.edit.cancel_btn"
                                    defaultMessage="Cancel"
                                />
                            </Link>
                            &nbsp;
                            &nbsp;
                            {
                                !this.state.authConnect &&
                                <ActionButton
                                    disabled={!this.submitButtonIsEnabled()}
                                    onClick={this.submitIntegration} type="submit" className="btn btn-primary">
                                    {this.props.intl.formatMessage(messages['submit_btn'])}
                                </ActionButton>
                            }
                        </div>
                    </div>
                    :
                    <div className="row justify-content-end">
                        <div className="col-6 text-align-right">
                            <Link to="/integrations/listing" className="btn btn-secondary">
                                <FormattedMessage
                                    id="integration.form.edit.back_btn"
                                    defaultMessage="Back to listing"
                                />
                            </Link>
                        </div>
                    </div>
            }
        </div>
    }

    render() {
        let form = ''
        switch (this.state.integrationKey) {
            case 'd-tools':
                form = <div className="col-12 ui-module">
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationApiKey">
                            <FormattedMessage
                                id="integration.form.edit.d_tools.api_key_label"
                                defaultMessage="API Key"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                name="configurationApiKey"
                                value={this.state.configuration.apiKey}
                                onChange={this.handleFormChange}
                                id="configurationApiKey"
                                type="text"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['api_key_placeholder'])}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="integration.form.edit.d_tools.api_key_description"
                                    defaultMessage="The api key is accessible in the integration menu in SI. {seeDocumentationLink}"
                                    values={{
                                        seeDocumentationLink: <a target="_blank"
                                            href="http://support.d-tools.com/Integrations_Support/Administrator_Guide/Manage_Integrations">
                                            <FormattedMessage
                                                id="integration.form.edit.d_tools.see_documentation_link"
                                                defaultMessage="See documentation"
                                            />
                                        </a>
                                    }}
                                />
                            </small>
                        </div>
                    </div>
                </div>
                break
            case 'stripe':
                form = <StripeForm
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                    locationIds={this.state.locationIds}
                    onLocationChange={(selectedlocationsIDs) => {
                        this.setState({
                            locationIds: selectedlocationsIDs.map(loc => loc.value)
                        })
                    }}
                    enabledFeatures={this.state.enabledFeatures}
                    onFeatureToggled={(paymentMethodTypeKey) => {
                        let features = this.state.enabledFeatures
                        features[paymentMethodTypeKey] = !this.state.enabledFeatures[paymentMethodTypeKey]
                        this.setState({
                            enabledFeatures: features,
                        })
                    }
                    }
                />
                break
            case 'paysafe':
                form = <div className="col-12 ui-module">
                    {this.state.configuration.USD_creditCard_accountId ? <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right"
                            htmlFor="configurationUSD_creditCard_accountId">
                            <FormattedMessage
                                id="integration.form.edit.paysafe.USD_credit_card_account_id_label"
                                defaultMessage="USD credit card account ID"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                disabled={true}
                                name="configurationUSD_creditCard_accountId"
                                value={this.state.configuration.USD_creditCard_accountId}
                                onChange={this.handleFormChange}
                                id="configurationUSD_creditCard_accountId"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div> : ''}
                    {this.state.configuration.CAD_creditCard_accountId ? <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right"
                            htmlFor="configurationCAD_creditCard_accountId">
                            <FormattedMessage
                                id="integration.form.edit.paysafe.CAD_credit_card_account_id_label"
                                defaultMessage="CAD credit card account ID"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                disabled={true}
                                name="configurationCAD_creditCard_accountId"
                                value={this.state.configuration.CAD_creditCard_accountId}
                                onChange={this.handleFormChange}
                                id="configurationCAD_creditCard_accountId"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div> : ''}
                    {this.state.configuration.USD_directDebit_accountId ? <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right"
                            htmlFor="configurationUSD_directDebit_accountId">
                            <FormattedMessage
                                id="integration.form.edit.paysafe.USD_direct_debit_account_id_label"
                                defaultMessage="USD direct debit account ID"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                disabled={true}
                                name="configurationUSD_directDebit_accountId"
                                value={this.state.configuration.USD_directDebit_accountId}
                                onChange={this.handleFormChange}
                                id="configurationUSD_directDebit_accountId"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div> : ''}
                    {this.state.configuration.CAD_directDebit_accountId ? <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right"
                            htmlFor="configurationCAD_directDebit_accountId">
                            <FormattedMessage
                                id="integration.form.edit.paysafe.CAD_direct_debit_account_id_label"
                                defaultMessage="CAD direct debit account ID"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                disabled={true}
                                name="configurationCAD_directDebit_accountId"
                                value={this.state.configuration.CAD_directDebit_accountId}
                                onChange={this.handleFormChange}
                                id="configurationCAD_directDebit_accountId"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div> : ''}
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationTestMode">
                            <FormattedMessage
                                id="integration.form.edit.paysafe.test_mode_label"
                                defaultMessage="Test mode"
                            />
                        </label>
                        <div className="col-9">
                            <Toggle
                                disabled={true}
                                id={"configurationTestMode"}
                                checked={this.state.configuration.testMode}
                                defaultChecked={this.state.configuration.testMode}
                                icons={false}
                                onChange={() => {
                                    const configuration = this.state.configuration
                                    configuration.testMode = !this.state.configuration.testMode
                                    this.setState({
                                        configuration: configuration,
                                    })
                                }} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-3 col-form-label text-align-right" />
                        <div className="col-9">
                            <a target={'_blank'}
                                href={this.state.configuration.testMode ? 'https://login.test.netbanx.com/' : 'https://login.netbanx.com/'}
                                className={'btn btn-success'}>
                                <FormattedMessage
                                    id="integration.form.edit.paysafe.connect_with_paysafe"
                                    defaultMessage="Open Paysafe NETBANX"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                if (this.state.id === '') {
                    let url = 'https://login.netbanx.com/office/public/registration.htm?pfToken=20204|69614'
                    if (AppContext.getAccount().attributes.currency === 'CAD') {
                        url = 'https://login.netbanx.com/office/public/registration.htm?pfToken=20204|68614'
                    }
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <div className="col-3 col-form-label text-align-right" />
                            <div className="col-9">
                                <ConnectIntegrationButton integrationKey={'paysafe'} url={url} />
                            </div>
                        </div>
                    </div>
                }
                break
            case 'custom-smtp':
                form = <div className="col-12 ui-module">
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationSenderEmail">
                            <FormattedMessage
                                id="integration.form.edit.custom_smtp.sender_email_label"
                                defaultMessage="Sender email"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                name="configurationSenderEmail"
                                value={this.state.configuration.senderEmail}
                                onChange={this.handleFormChange}
                                id="configurationSenderEmail"
                                type="text"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['smtp_sender_email_placeholder'])}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="integration.form.edit.custom_smtp.sender_email_description"
                                    defaultMessage="The email will be used in the from of all emails send to your customers."
                                />
                            </small>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationHost">
                            <FormattedMessage
                                id="integration.form.edit.custom_smtp.host_label"
                                defaultMessage="Host"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                name="configurationHost"
                                value={this.state.configuration.host}
                                onChange={this.handleFormChange}
                                id="configurationHost"
                                type="text"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['smtp_host_placeholder'])}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="integration.form.edit.custom_smtp.host_description"
                                    defaultMessage="Host of your smtp server."
                                />
                            </small>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationPort">
                            <FormattedMessage
                                id="integration.form.edit.custom_smtp.port_label"
                                defaultMessage="Port"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                name="configurationPort"
                                value={this.state.configuration.port}
                                onChange={this.handleFormChange}
                                id="configurationPort"
                                type="text"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['smtp_port_placeholder'])}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="integration.form.edit.custom_smtp.port_description"
                                    defaultMessage="Port of your smtp server. Use the SSL or non-SSL port (not TLS)."
                                />
                            </small>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationIsTls">
                            <FormattedMessage
                                id="integration.form.edit.custom_smtp.is_tls_label"
                                defaultMessage="TLS"
                            />
                        </label>
                        <div className="col-9 py-1">
                            <Toggle
                                defaultChecked={this.state.configuration.isTls}
                                checked={this.state.configuration.isTls}
                                icons={false}
                                onChange={() => {
                                    const conf = this.state.configuration
                                    conf.isTls = !this.state.configuration.isTls
                                    this.setState({
                                        configuration: conf,
                                    })
                                }} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationUsername">
                            <FormattedMessage
                                id="integration.form.edit.custom_smtp.username_label"
                                defaultMessage="Username"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                name="configurationUsername"
                                value={this.state.configuration.username}
                                onChange={this.handleFormChange}
                                id="configurationUsername"
                                type="text"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['smtp_username_placeholder'])}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="integration.form.edit.custom_smtp.username_description"
                                    defaultMessage="Username or email used to login to your mailbox."
                                />
                            </small>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationPassword">
                            <FormattedMessage
                                id="integration.form.edit.custom_smtp.password_label"
                                defaultMessage="Password"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                name="configurationPassword"
                                value={this.state.configuration.password}
                                onChange={this.handleFormChange}
                                id="configurationPassword"
                                type="password"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['smtp_password_placeholder'])}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="integration.form.edit.custom_smtp.password_description"
                                    defaultMessage="Password used to login to your mailbox."
                                />
                            </small>
                        </div>
                    </div>
                </div>
                break
            case 'calendly':
                form = <div className="col-12 ui-module">
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="configurationApiKey">
                            <FormattedMessage
                                id="integration.form.edit.calendly.api_key_label"
                                defaultMessage="API Key"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                name="configurationApiKey"
                                value={this.state.configuration.apiKey}
                                onChange={this.handleFormChange}
                                id="configurationApiKey"
                                type="text"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['calendly_api_key_placeholder'])}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="integration.form.edit.calendly.api_key_description"
                                    defaultMessage="The api key is available from your Calendly account in Account > Integrations. {seeDocumentationLink}"
                                    values={{
                                        seeDocumentationLink: <a target="_blank"
                                            href="https://calendly.com/integrations">
                                            <FormattedMessage
                                                id="integration.form.edit.calendly.see_documentation_link"
                                                defaultMessage="Open integrations"
                                            />
                                        </a>
                                    }}
                                />
                            </small>
                        </div>
                    </div>
                </div>
                break
            case 'quick-books':
                if (this.state.id !== '') {
                    form = <QuickbooksForm
                        configuration={this.state.configuration}
                        enabledFeatures={this.state.enabledFeatures}
                        configurationValues={this.state.configurationValues.map(cv => {
                            return new IntegrationConfigurationValue(cv)
                        })}
                        onFeatureToggled={(featureKey) => {
                            let features = this.state.enabledFeatures
                            features[featureKey] = !this.state.enabledFeatures[featureKey]
                            this.setState({
                                enabledFeatures: features,
                            })
                        }}
                        onConfigurationChange={(updatedConfiguration) => {
                            this.setState({
                                configuration: updatedConfiguration,
                            })
                        }}
                        toggleSaveButtonStatus={(enabled) => this.setState({
                            isEnabled: enabled
                        })}
                    />
                } else {
                    const url = AppContext.getOptions().apiUrl + '/openid/connect/quick-books/' +
                        AppContext.getUserLoggedIn().id + '?r=/integrations/listing'
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right">
                                <FormattedMessage
                                    id="integration.form.edit.quickbooks.connect"
                                    defaultMessage="Connect"
                                />
                            </label>
                            <div className="col-9">
                                <a href={url}>
                                    <img src={'/images/quickbooks_connect_btn_en.svg'} height={'40px'} />
                                </a>
                            </div>
                        </div>
                    </div>
                }
                break
            case integrationKeyZapierMu2:
                if (this.state.id !== '') {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.api_key"
                                    defaultMessage="MU2 API Key"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="apiKey"
                                    value={this.state.configuration.apiKey}
                                    disabled={true}
                                    id="apiKey"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.quotemachine_account_id"
                                    defaultMessage="QuoteMachine Account ID"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="accountId"
                                    value={AppContext.getAccount().id}
                                    disabled={true}
                                    id="accountId"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="userId">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.quotemachine_user_id"
                                    defaultMessage="QuoteMachine User ID"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="userId"
                                    value={this.state.createdByUserId}
                                    disabled={true}
                                    id="userId"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                } else {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row justify-content-center">
                            <div className="col-12 col-md-6 text-center pt-3">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.create_account"
                                    defaultMessage="An account will be automatically created in MU2. You will be contacted to connect your Zapier account with QuoteMachine."
                                />
                            </div>
                        </div>
                    </div>
                }
                break
            case integrationKeyZapier:
                if (this.state.id !== '') {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.public_key"
                                    defaultMessage="Public Key"
                                />
                            </label>
                            <div className="col-9">
                                <CopyableInputForm
                                    name="publicKey"
                                    value={this.state.publicKey}
                                    id="publicKey"
                                    btnClassName="btn-secondary"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.secret_key"
                                    defaultMessage="Secret Key"
                                />
                            </label>
                            <div className="col-9">
                                <CopyableInputForm
                                    name="secretKey"
                                    value={this.state.secretKey}
                                    type="password"
                                    id="secretKey"
                                    btnClassName="btn-secondary"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId" />
                            <div className="col-9">
                                <a href={'#'} onClick={this.openIntercom}>
                                    <FormattedMessage
                                        id="integration.form.edit.zapier.get_an_invite"
                                        defaultMessage="If you don't see QuoteMachine app on your account, contact us and we'll send you an invite."
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                } else {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row justify-content-center">
                            <div className="col-12 col-md-6 text-center pt-3">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.create_account_original"
                                    defaultMessage="Activate your QuoteMachine account to get your public and secret key"
                                />
                            </div>
                        </div>
                    </div>
                }

                break
            case 'zendesk-support-mu2':
                if (this.state.id !== '') {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.api_key"
                                    defaultMessage="MU2 API Key"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="apiKey"
                                    value={this.state.configuration.apiKey}
                                    disabled={true}
                                    id="apiKey"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.quotemachine_account_id"
                                    defaultMessage="QuoteMachine Account ID"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="accountId"
                                    value={AppContext.getAccount().id}
                                    disabled={true}
                                    id="accountId"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="userId">
                                <FormattedMessage
                                    id="integration.form.edit.zapier.quotemachine_user_id"
                                    defaultMessage="QuoteMachine User ID"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="userId"
                                    value={this.state.createdByUserId}
                                    disabled={true}
                                    id="userId"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                } else {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row justify-content-center">
                            <div className="col-12 col-md-6 text-center pt-3">
                                <FormattedMessage
                                    id="integration.form.edit.zendesk_support.create_account"
                                    defaultMessage="An account will be automatically created in MU2. You will be contacted to connect your Zendesk Support account with QuoteMachine."
                                />
                            </div>
                        </div>
                    </div>
                }
                break
            case integrationKeyKangaroo:
                if (this.state.id !== '') {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                                <FormattedMessage
                                    id="integration.form.edit.kangaroo.business_id"
                                    defaultMessage="Business ID"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="businessId"
                                    value={this.state.configuration.businessId}
                                    disabled={true}
                                    id="businessId"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                } else {
                    const url = AppContext.getOptions().apiUrl + '/openid/connect/kangaroo/' +
                        AppContext.getUserLoggedIn().id + '?r=/integrations/listing?open=kangaroo'
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right">
                                <FormattedMessage
                                    id="integration.form.edit.kangaroo.connect"
                                    defaultMessage="Connect"
                                />
                            </label>
                            <div className="col-9">
                                <ConnectIntegrationButton integrationKey={'kangaroo'} url={url} />
                            </div>
                        </div>
                    </div>
                }
                break
            case integrationKeyZendeskSell:
                if (this.state.id !== '') {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                                <FormattedMessage
                                    id="integration.form.edit.zendesk_sell.account_id"
                                    defaultMessage="Account ID"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="accountId"
                                    value={this.state.configuration.accountId}
                                    disabled={true}
                                    id="accountId"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                } else {
                    const url = AppContext.getOptions().apiUrl + '/openid/connect/zendesk-sell/' +
                        AppContext.getUserLoggedIn().id + '?r=/integrations/listing?open=zendesk-sell'
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right">
                                <FormattedMessage
                                    id="integration.form.edit.zendesk_sell.connect"
                                    defaultMessage="Connect"
                                />
                            </label>
                            <div className="col-9">
                                <a href={url} className={'btn btn-secondary'}>
                                    <FormattedMessage
                                        id="integration.form.edit.zendesk_sell.connect_with_zendesk_sell"
                                        defaultMessage="Connect with Zendesk Sell"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                }
                break
            case INTEGRATION_KEY.VEND:
                form = <VendForm
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                    configurationValues={this.state.configurationValues.map(cv => {
                        return new IntegrationConfigurationValue(cv)
                    })}
                    enabledFeatures={this.state.enabledFeatures}
                    onFeatureToggled={(featureKey) => {
                        let features = this.state.enabledFeatures
                        features[featureKey] = !this.state.enabledFeatures[featureKey]
                        this.setState({
                            enabledFeatures: features,
                        })
                    }}
                    onConfigurationChange={(updatedConfiguration) => {
                        this.setState({
                            configuration: updatedConfiguration,
                        })
                    }}
                    toggleSaveButtonStatus={(enabled) => this.setState({
                        isEnabled: enabled
                    })}
                />
                break
            case INTEGRATION_KEY.LIGHTSPEED_RETAIL:
                form = <LsRetailForm
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                    configurationValues={this.state.configurationValues.map(cv => {
                        return new IntegrationConfigurationValue(cv)
                    })}
                    enabledFeatures={this.state.enabledFeatures}
                    onFeatureToggled={(featureKey) => {
                        let features = this.state.enabledFeatures
                        features[featureKey] = !this.state.enabledFeatures[featureKey]
                        this.setState({
                            enabledFeatures: features,
                        })
                    }}
                    onConfigurationChange={(updatedConfiguration) => {
                        this.setState({
                            configuration: updatedConfiguration,
                        })
                    }}
                    toggleSaveButtonStatus={(enabled) => this.setState({
                        isEnabled: enabled
                    })}
                />
                break
            case 'ls-ecom':
            case 'ls-ecom-omni':
            case 'ls-ecom-omni-na':
                if (this.state.id !== '') {
                    form = <LSEcomForm
                        configuration={this.state.configuration}
                        integrationKey={this.state.integrationKey}
                        authConnect={this.state.authConnect}
                        submitIntegration={(formOptions) => this.submitIntegration("", formOptions)}
                        submitButtonIsEnabled={this.submitButtonIsEnabled()}
                        deleteIntegration={() => this.deleteIntegration()}
                        enabledFeatures={this.state.enabledFeatures}
                        onFeatureToggled={(featureKey) => {
                            let features = this.state.enabledFeatures
                            features[featureKey] = !this.state.enabledFeatures[featureKey]
                            this.setState({
                                enabledFeatures: features,
                            })
                        }}
                        onConfigurationChange={(updatedConfiguration) => {
                            this.setState({
                                configuration: updatedConfiguration,
                            })
                        }}
                    />
                }
                break
            case "shopify":
            case "shopify-expert-app":
                if (this.state.id !== '') {
                    form = <ShopifyForm
                        integrationConfigurationId={this.state.id}
                        configuration={this.state.configuration}
                        configurationValues={this.state.configurationValues.map(cv => {
                            return new IntegrationConfigurationValue(cv)
                        })}
                        enabledFeatures={this.state.enabledFeatures}
                        onFeatureToggled={(featureKey) => {
                            let features = this.state.enabledFeatures
                            features[featureKey] = !this.state.enabledFeatures[featureKey]
                            this.setState({
                                enabledFeatures: features,
                            })
                        }}
                        onConfigurationChange={(updatedConfiguration) => {
                            this.setState({
                                configuration: updatedConfiguration,
                            })
                        }}
                    />
                } else {
                    //probably need to redirect to Shopify somehow
                }
                break
            case 'outlook':
                form = <div className="col-12 ui-module">
                    <div className="form-group row">
                        <label className="col-3 col-form-label text-align-right" htmlFor="lsGolfAccountId">
                            <FormattedMessage
                                id="integration.form.edit.account_id"
                                defaultMessage="Account ID"
                            />
                        </label>
                        <div className="col-9">
                            <input
                                name="accountId"
                                value={this.state.configuration.accountId}
                                disabled={true}
                                id="accountId"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                break
            case integrationKeyLightspeedGolf:
                form = this.getLightspeedGolfForm()
                break
            case 'square':
                if (this.state.id !== '') {
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="accountId">
                                <FormattedMessage
                                    id="integration.form.edit.square.account_id"
                                    defaultMessage="Account ID"
                                />
                            </label>
                            <div className="col-9">
                                <input
                                    name="accountId"
                                    value={this.state.configuration.accountId}
                                    disabled={true}
                                    id="accountId"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        {this.renderFeatureToggles()}
                        {this.renderConfigurationValues()}
                    </div>
                } else {
                    const url = AppContext.getOptions().apiUrl + '/openid/connect/square/' +
                        AppContext.getUserLoggedIn().id + '?r=/integrations/listing?open=square'
                    form = <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right">
                                <FormattedMessage
                                    id="integration.form.edit.connect"
                                    defaultMessage="Connect"
                                />
                            </label>
                            <div className="col-9">
                                <ConnectIntegrationButton integrationKey="square" url={url} />
                            </div>
                        </div>
                    </div>
                }
                break
            case INTEGRATION_KEY.SQUARE_PAYMENTS:
                form = <SquarePaymentsFormComponent
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                />
                break
            case INTEGRATION_KEY.PIPEDRIVE:
                form = <PipedriveFormComponent
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                    configurationValues={this.state.configurationValues}
                    onConfigurationChange={(updatedConfiguration) => {
                        this.setState({
                            configuration: updatedConfiguration,
                        })
                    }}
                />
                break
            case INTEGRATION_KEY.ZENDESK_SUPPORT:
                form = <ZendeskSupportFormComponent
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                    configurationValues={this.state.configurationValues}
                    onConfigurationChange={(updatedConfiguration) => {
                        this.setState({
                            configuration: updatedConfiguration,
                        })
                    }}
                />
                break
            case INTEGRATION_KEY.WIX:
                    form = <WixFormComponent
                        integrationConfigurationId={this.state.id}
                        configuration={this.state.configuration}
                        authConnect={this.state.authConnect}
                        configurationValues={this.state.configurationValues}
                        submitIntegration={(formOptions) => this.submitIntegration("", formOptions)}
                        deleteIntegration={(e) => this.deleteIntegration(e)}
                        onConfigurationChange={(updatedConfiguration) => {
                            this.setState({
                                configuration: updatedConfiguration,
                            })
                        }}
                        toggleSaveButtonStatus={(enabled) => this.setState({
                            isEnabled: enabled
                        })}
                    />
                    break
            case INTEGRATION_KEY.RAINFOREST:
                form = <RainforestFormComponent
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                />
                break
            case INTEGRATION_KEY.HUBSPOT:
                form = <HubSpotFormComponent
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                />
                break
            case INTEGRATION_KEY.MAILCHIMP:
                form = <MailchimpEditForm
                    configurationId={this.state.id}
                    configuration={this.state.configuration}
                    configurationValues={this.state.configurationValues}
                    enabledFeatures={this.state.enabledFeatures}
                    onChange={(updatedConfiguration) => {
                        this.setState({
                            updatedConfiguration
                        })
                    }} />
                break
            case INTEGRATION_KEY.FRESHBOOKS:
                form = <FreshbooksFormComponent
                    integrationConfigurationId={this.state.id}
                    configuration={this.state.configuration}
                    configurationValues={this.state.configurationValues}
                    onConfigurationChange={(updatedConfiguration) => {
                        this.setState({
                            configuration: updatedConfiguration,
                        })
                    }}
                    toggleSaveButtonStatus={(enabled) => this.setState({
                        isEnabled: enabled
                    })}
                />
                break
        }
        return (
            <div>
                {this.state.isLoading ?
                    <LoadingSpinner /> :
                    <form onSubmit={this.submitIntegration}>
                        <div className="row ui-has-modules">
                            <div className="col-12">
                                {this.state.formStatus}
                            </div>
                            {form}
                            {this.getFormFooter()}
                        </div>
                    </form >
                }
            </div>
        );
    }
}
export default injectIntl(IntegrationEditForm)


// WEBPACK FOOTER //
// ./src/integration/form/edit.component.jsx